import React, { useState } from "react";
import { StyleSheet, TextInput, View } from "react-native";
import MaterialIcons from "@expo/vector-icons/MaterialIcons";

export function EditTextPassword({ placeholder, style, onChangeText, onBlur }) {
  const [showPassword, setShowPassword] = useState(true);
  const [icon, setIcon] = useState("visibility");
  const [newStyle, setNewStyle] = useState(styles.container);

  return (
    <View style={[newStyle, style]}>
      <TextInput
        style={styles.textInput}
        placeholder={placeholder}
        secureTextEntry={showPassword}
        autoFocus={false}
        onBlur={() => {
          onBlur;
          setNewStyle(styles.container);
        }}
        onFocus={(e) => {
          setNewStyle(styles.textInputFocus);
        }}
        onChangeText={(text) => onChangeText(text)}
      />
      <MaterialIcons
        name={icon}
        size={24}
        color="#CECECE"
        style={styles.icon}
        onPress={() => {
          setShowPassword(!showPassword);
          if (icon === "visibility") setIcon("visibility-off");
          else setIcon("visibility");
        }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  icon: {
    paddingHorizontal: 16,
  },
  container: {
    minWidth: 300,
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 2,
    height: 55,
    borderColor: "#A0A0A0",
    borderRadius: 4,
  },
  textInput: {
    paddingHorizontal: 16,
    paddingVertical: 16,
    fontSize: 16,
    flex: 1,
    outlineStyle: "none",
  },
  textInputFocus: {
    minWidth: 300,
    flexDirection: "row",
    borderWidth: 2,
    alignItems: "center",
    borderRadius: 4,
    height: 55,
    borderColor: "#01786E",
  },
});
